"use client";

import * as React from "react";
import { cn } from "@/utils";

interface EquationProps {
  className?: string;
  children: React.ReactNode;
  variant?: "boxed" | "plain";
}

export function Equation({
  children,
  className,
  variant = "boxed",
}: EquationProps) {
  return (
    <div
      className={cn(
        variant === "boxed" &&
          "rounded-xl border border-white/[0.08] bg-surface-300/30 px-5 py-4 font-mono text-sm leading-relaxed text-hex-400/90 backdrop-blur-sm",
        variant === "plain" &&
          "font-mono text-sm leading-relaxed text-muted",
        className,
      )}
    >
      {children}
    </div>
  );
}

export default Equation;
